export const defaultStyles = {
  objectFit: "cover",
  objectPosition: "center",
  opacity: 1,
  borderRadius: {
    border_left_top_radius: 0,
    border_left_bottom_radius: 0,
    border_right_top_radius: 0,
    border_right_bottom_radius: 0,
  },
  sizing: {
    width: "100%",
    height: "auto",
    minWidth: "100px",
    minHeight: "auto",
    maxWidth: "100%",
    maxHeight: "auto",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingRight: "0",
    paddingLeft: "0",
  },
  margin: {
    marginTop: "12",
    marginBottom: "12",
    marginRight: "24",
    marginLeft: "24",
  },
} as const;
